import * as apis from "@/apis/forget";

export default {
    getCaptchaFFTR(context, params) {
        return apis.getCaptcha(params);
    },
    verifyAccount(context, params) {
        return apis.verifyAccount(params);
    },
    sendCodeFFTR(context, params) {
        return apis.sendCode(params);
    },
    verifyCodeFFTR(context, params) {
        return apis.verifyCode(params);
    },
    verifyQaFFTR(context, params) {
        return apis.verifyQa(params);
    }
};
